(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ApplicationFeature', ApplicationFeature);

    ApplicationFeature.$inject = ['$resource'];

    function ApplicationFeature ($resource) {
        var resourceUrl =  'api/application-features/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
